
<mat-card class="breadcrumb">
    <div class="row">
        <div class="col-md-7">
            <!--<a [routerLink]="['/dashboard']">Dashboard</a>-->
            <!--<mat-icon>arrow_forward_ios</mat-icon>-->
            <a [routerLink]="['/photo']">Photo of the Week</a>
        </div>
        <div class="col-md-5 text-right">
        </div>
    </div>
</mat-card>



<mat-card class="mt-3">

    <h3 class="mat-title">Photo of the Week</h3>

    <div class="row">
        <div class="col-md-6">
            <p>Upload a photo of the week here, assign the brand to the photo and they will recieve 5 additional feedback points</p>
            <p>Each weeks photo will be distributed on the feedback league email and then marked as completed</p>
            <p>If no new photo is uploaded after the current one has been applied then it is assumed there is no photo of the week for the upcoming email</p>


        </div>
        <div class="col-md-6">
            <app-image-upload [ownerID]="'ABC'" [type]="'photoOfWeek'" [text]="'Click here to upload photo'" (imageUploaded)="setImage($event)"></app-image-upload>
        </div>
    </div>
</mat-card>
<mat-card class="mt-3" *ngIf="photo">
    <h3 class="mat-title">Winning image for feedback week {{photo.weekNoNext}}</h3>
    <div class="row">
        <div class="col-md-4">
            <img *ngIf="!photo" src="/assets/images/nia.png" class="img-fluid" style="max-height: 150px" />
            <div *ngIf="photo" class="text-center" style="padding: 3px; border: 1px solid #EEE;">
                <img [src]="photo.url" class="img-fluid" style="max-height: 250px;" />
            </div>
        </div>
        <div class="col-md-8">
            <div style="max-width: 500px;">
            <p class="mb-0">Overview text</p>
            <input type="text" class="form-control" [(ngModel)]="photo.description">

            <p class="mt-4 mb-0">Select winning brand - 5 points will be awarded</p>
            <select class="form-control" [(ngModel)]="photo.hotel.id">
                <option [ngValue]="+b.id" *ngFor="let b of businesses">{{b.name}}</option>
            </select>

            <div class="mt-4">
                <button type="button" class="btn btn-primary" (click)="savePhotoData()">Submit</button>
            </div>

            <div class="alert alert-success mt-4" *ngIf="complete">
                <p class="mb-0">Your photo has been saved</p>
            </div>
            </div>
        </div>
    </div>

</mat-card>


